import { PayloadAction } from "@reduxjs/toolkit";
import { call, CallEffect, put, PutEffect } from "redux-saga/effects";
import { updateDocumentCategory } from "../api/documentsApi";
import { updateCategoryFailure } from "./documentsSlice";

export function* handleUpdateCategory(
  action: PayloadAction<{
    documentId: string;
    categoryId: string;
    rerunInsights?: boolean;
  }>
): Generator<CallEffect | PutEffect, void, any> {
  try {
    yield call(
      updateDocumentCategory,
      action.payload.documentId,
      action.payload.categoryId,
      action.payload.rerunInsights
    );
  } catch (error) {
    yield put(
      updateCategoryFailure(
        error instanceof Error ? error.message : "Category update failed"
      )
    );
  }
}
